import { cn } from '#/shared/lib/utils'
import { LockIcon } from '#/shared/ui/icons'

interface AccessDeniedProps {
  title: string
  description: string
  /** Usually a way out — a link home or to whoever can grant access. */
  action?: React.ReactNode
  className?: string
}

/**
 * Stands in for a screen the viewer's role can't see (the API answered 403).
 * Takes the page's place instead of an empty table, which would read as "no
 * data yet" and invite them to create something they can't.
 */
export function AccessDenied({
  title,
  description,
  action,
  className,
}: AccessDeniedProps) {
  return (
    <section
      aria-labelledby="access-denied-title"
      className={cn(
        'flex flex-1 flex-col items-center justify-center gap-4 rounded-xl border border-gray-200 bg-white px-4 py-16 text-center',
        className,
      )}
    >
      <span className="flex size-10 items-center justify-center rounded-full bg-gray-100 text-gray-500">
        <LockIcon aria-hidden="true" className="size-5" />
      </span>
      <div className="flex flex-col items-center gap-1">
        <h2
          id="access-denied-title"
          className="text-base font-semibold text-gray-900"
        >
          {title}
        </h2>
        <p className="max-w-sm text-sm text-gray-500">{description}</p>
      </div>
      {action}
    </section>
  )
}
